module.exports = function computeCacheStateForScripts(opts) {
    opts = opts || {}

    var onlySameOrigin = opts.onlySameOrigin !== false
    var pathPrefixes = opts.pathPrefixes || []

    if (typeof window === 'undefined' || typeof performance === 'undefined') {
        return 'unknown'
    }

    if (!performance.getEntriesByType) {
        return 'unknown'
    }

    var entries = performance.getEntriesByType('resource') || []
    var origin = window.location.origin

    var scripts = entries.filter(function(e) {
        if (!e || typeof e.name !== 'string') {
            return false
        }

        if (e.initiatorType !== 'script') {
            return false
        }

        if (!/\.js(\?|$)/i.test(e.name)) {
            return false
        }

        var url
        try {
            url = new URL(e.name, window.location.href)
        } catch(err) {
            return false
        }

        if (onlySameOrigin && url.origin !== origin) {
            return false
        }

        if (pathPrefixes.length > 0) {
            var ok = pathPrefixes.some(function(p) {
                return url.pathname.indexOf(p) === 0
            })

            if (!ok) {
                return false
            }
        }

        return true
    })

    if (scripts.length === 0) {
        return 'unknown'
    }

    var fetched = 0

    scripts.forEach(function(e) {
        if ((e.transferSize || 0) > 0) {
            fetched++
        }
    })

    if (fetched === scripts.length) {
        return 'cold'
    }

    if (fetched === 0) {
        return 'warm'
    }

    return 'mixed'
}
